const translations = { selectChecklistTypes: 'Checklist type selection', type: 'Type', checklistType: 'Checklist type' }

export default translations
